import { useChainSettingsApiQuery } from '../chain-settings/useChainSettingsApiQuery';

export const useBuyingEventPlanningLevel = () => {
    const { data } = useChainSettingsApiQuery();
    return data?.buyingEventPlanningLevel;
};
